/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  cta: {
    connexion: 'Accesso',
    login: 'Accedi',
    logout: 'Disconnettersi',
    send: 'Invia',
    donate: 'Donare',
    description: 'Descrizione',
    history: 'Storico',
    goto_forgot_password: 'Password dimenticata?',
    goto_login: 'Torna alla schermata di accesso',
    start: 'Iniziare la sessione',
    settings: 'Configura l’effetto',
    start_exercise: 'Iniziare',
    restart: 'Ripetere',
    restart_exercise: 'Continuare l’esercizio',
    pause_exercise: 'Pausa',
    skip_exercise: 'Salta',
    next_exercise: 'Successivo',
    authorize: 'Consentire',
    cancel: 'Annulla',
    close: 'Chiudere',
    save: 'Salvare',
    modify: 'Modifica',
    back: 'Ritorna',
    confirm: 'Ok',
    support: 'Aiuto',
    verify: 'Verificare',
    mfa_resend: 'Invia nuovamente il codice',
  },
};
